// ServerManagement.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import API_URL from './config';
import './ServerManagement.css'; // Importa o arquivo CSS

function ServerManagement({ token }) {
  const [servers, setServers] = useState([]);
  const [newServer, setNewServer] = useState({
    name: '',
    host: '',
    port: 7020, // Porta SSH padrão
    username: 'root', // Usuário SSH padrão
    password: '', // Senha SSH — sem valor padrão (obrigatória no cadastro)
    db_user: '', // Novo campo para usuário do banco
    db_password: '', // Novo campo para senha do banco
    db_name: 'asteriskcdrdb',
    recordings_path: '/var/spool/asterisk/monitor',
    is_active: true,
    description: ''
  });
  const [editingServer, setEditingServer] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [testingConnection, setTestingConnection] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const fetchServers = useCallback(async () => {
    try {
      // CORREÇÃO: Usando a variável de ambiente para a URL da API
      const response = await axios.get(`${API_URL}/issabelServers`, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      });

      console.log("Servidores recebidos:", response.data);
      setServers(response.data);
    } catch (err) {
      console.error("Erro ao buscar servidores:", err);
      setError('Erro ao buscar servidores');
    }
  }, [token]);

  useEffect(() => {
    fetchServers();
  }, [fetchServers]);

  const handleAddServer = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      if (!newServer.name.trim() || !newServer.host.trim() || !newServer.password || !newServer.db_user || !newServer.db_password) {
        setError('Nome, host, senha SSH, usuário do BD e senha do BD são obrigatórios.');
        setLoading(false);
        return;
      }

      const serverData = {
        name: newServer.name.trim(),
        host: newServer.host.trim(),
        port: newServer.port || 7020,
        username: newServer.username || 'root',
        password: newServer.password,
        db_user: newServer.db_user,
        db_password: newServer.db_password,
        db_name: 'asteriskcdrdb',
        recordings_path: newServer.recordings_path || '/var/spool/asterisk/monitor',
        is_active: newServer.is_active !== false,
        description: newServer.description || ''
      };

      // CORREÇÃO: Usando a variável de ambiente para a URL da API
      await axios.post(`${API_URL}/issabelServers`, serverData, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      });

      setNewServer({
        name: '',
        host: '',
        port: 7020,
        username: 'root',
        password: '',
        db_user: '',
        db_password: '',
        db_name: 'asteriskcdrdb',
        recordings_path: '/var/spool/asterisk/monitor',
        is_active: true,
        description: ''
      });
      setSuccess('Servidor adicionado com sucesso!');
      await fetchServers();
    } catch (err) {
      console.error("Erro ao adicionar servidor:", err);
      setError(`Erro ao adicionar servidor: ${err.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateServer = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      if (!editingServer.name.trim() || !editingServer.host.trim() || !editingServer.db_user) {
        setError('Nome, host e usuário do BD são obrigatórios.');
        setLoading(false);
        return;
      }

      const updateData = {
        name: editingServer.name.trim(),
        host: editingServer.host.trim(),
        port: editingServer.port || 7020,
        username: editingServer.username || 'root',
        db_user: editingServer.db_user,
        db_name: 'asteriskcdrdb',
        recordings_path: editingServer.recordings_path || '/var/spool/asterisk/monitor',
        is_active: editingServer.is_active !== false,
        description: editingServer.description || ''
      };

      if (editingServer.password) {
        updateData.password = editingServer.password;
      }

      if (editingServer.db_password) {
        updateData.db_password = editingServer.db_password;
      }

      // CORREÇÃO: Usando a variável de ambiente para a URL da API
      await axios.put(`${API_URL}/issabelServers/${editingServer.id}`, updateData, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      });

      setSuccess('Servidor atualizado com sucesso!');
      setEditingServer(null);
      setTestResult(null);
      await fetchServers();
    } catch (err) {
      console.error("Erro ao atualizar servidor:", err);
      setError(`Erro ao atualizar servidor: ${err.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteServer = async (serverId) => {
    if (window.confirm('Tem certeza que deseja excluir este servidor?')) {
      try {
        // CORREÇÃO: Usando a variável de ambiente para a URL da API
        await axios.delete(`${API_URL}/issabelServers/${serverId}`, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        setSuccess('Servidor excluído com sucesso!');
        await fetchServers();
      } catch (err) {
        console.error("Erro ao excluir servidor:", err);
        setError(`Erro ao excluir servidor: ${err.response?.data?.message || err.message}`);
      }
    }
  };

  const testConnection = async (server) => {
    setTestingConnection(true);
    setTestResult(null);
    setError('');

    try {
      const isEditing = !!editingServer;

      const testData = {
        host: server.host,
        db_user: server.db_user,
        db_password: server.db_password,
        isEditing: isEditing,
        serverId: isEditing ? editingServer.id : null
      };

      // CORREÇÃO: Usando a variável de ambiente para a URL da API
      await axios.post(`${API_URL}/issabelServers/test-connection`, testData, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      });

      setTestResult({
        success: true,
        message: 'Conexão estabelecida com sucesso!'
      });
    } catch (err) {
      console.error("Erro ao testar conexão:", err);
      setTestResult({
        success: false,
        message: `Falha na conexão: ${err.response?.data?.message || err.message}`
      });
    } finally {
      setTestingConnection(false);
    }
  };

  const startEditing = (server) => {
    console.log("Iniciando edição do servidor:", server);
    setEditingServer({
      ...server,
      password: '', // Limpar senha SSH ao editar
      db_password: '' // Limpar senha BD ao editar
    });
    setTestResult(null);
  };

  const cancelEditing = () => {
    setEditingServer(null);
    setTestResult(null);
  };

  return (
    <div className="server-management-container">
      <h1 className="server-management-title">Gerenciamento de Servidores Issabel</h1>

      {success && <div className="message message-success">{success}</div>}
      {error && <div className="message message-error">{error}</div>}

      {/* Formulário de Edição */}
      {editingServer ? (
        <div className="edit-server-section">
          <h2>Editar Servidor: {editingServer.name}</h2>
          <form onSubmit={handleUpdateServer} className="form-card">
            <div className="form-grid">
              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="edit-name" className="form-label">
                    Nome do Servidor: <span className="required-star">*</span>
                  </label>
                  <input
                    id="edit-name"
                    type="text"
                    placeholder="Nome descritivo do servidor"
                    value={editingServer.name}
                    onChange={(e) => setEditingServer({ ...editingServer, name: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>

                <div className="form-col-50">
                  <label htmlFor="edit-host" className="form-label">
                    Host: <span className="required-star">*</span>
                  </label>
                  <input
                    id="edit-host"
                    type="text"
                    placeholder="IP ou domínio do servidor"
                    value={editingServer.host}
                    onChange={(e) => setEditingServer({ ...editingServer, host: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>
              </div>

              {/* Seção de credenciais SSH (Edição) */}
              <div className="form-row">
                <div className="section-header">Credenciais de Acesso SSH</div>
              </div>

              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="edit-ssh-username" className="form-label">
                    Usuário SSH:
                  </label>
                  <input
                    id="edit-ssh-username"
                    type="text"
                    placeholder="root"
                    value={editingServer.username || ''}
                    onChange={(e) => setEditingServer({ ...editingServer, username: e.target.value })}
                    className="input-field"
                  />
                </div>

                <div className="form-col-50">
                  <label htmlFor="edit-ssh-password" className="form-label">
                    Senha SSH: (deixe vazio para manter)
                  </label>
                  <input
                    id="edit-ssh-password"
                    type="password"
                    placeholder="Nova senha SSH"
                    value={editingServer.password || ''}
                    onChange={(e) => setEditingServer({ ...editingServer, password: e.target.value })}
                    className="input-field"
                  />
                </div>
              </div>

              {/* Seção de credenciais de banco de dados (Edição) */}
              <div className="form-row">
                <div className="section-header">Credenciais do Banco de Dados</div>
              </div>

              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="edit-db-user" className="form-label">
                    Usuário DB: <span className="required-star">*</span>
                  </label>
                  <input
                    id="edit-db-user"
                    type="text"
                    placeholder="Usuário do banco de dados"
                    value={editingServer.db_user || ''}
                    onChange={(e) => setEditingServer({ ...editingServer, db_user: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>

                <div className="form-col-50">
                  <label htmlFor="edit-db-password" className="form-label">
                    Senha DB: (deixe vazio para manter)
                  </label>
                  <input
                    id="edit-db-password"
                    type="password"
                    placeholder="Nova senha do banco de dados"
                    value={editingServer.db_password || ''}
                    onChange={(e) => setEditingServer({ ...editingServer, db_password: e.target.value })}
                    className="input-field"
                  />
                </div>
              </div>

              <div className="form-row">
                <label htmlFor="edit-db-name" className="form-label">
                  Banco de Dados:
                </label>
                <input
                  id="edit-db-name"
                  type="text"
                  value="asteriskcdrdb"
                  className="input-field input-disabled"
                  disabled
                />
              </div>

              {/* Configurações adicionais (Edição) */}
              <div className="form-row">
                <div className="section-header">Configurações Adicionais</div>
              </div>

              <div className="form-row">
                <label htmlFor="edit-recordings-path" className="form-label">
                  Caminho das Gravações:
                </label>
                <input
                  id="edit-recordings-path"
                  type="text"
                  placeholder="/var/spool/asterisk/monitor"
                  value={editingServer.recordings_path || ''}
                  onChange={(e) => setEditingServer({ ...editingServer, recordings_path: e.target.value })}
                  className="input-field"
                />
              </div>

              <div className="form-row">
                <label htmlFor="edit-description" className="form-label">
                  Descrição:
                </label>
                <textarea
                  id="edit-description"
                  placeholder="Descrição ou observações sobre este servidor"
                  value={editingServer.description || ''}
                  onChange={(e) => setEditingServer({ ...editingServer, description: e.target.value })}
                  className="input-field textarea-field"
                />
              </div>

              <div className="checkbox-group">
                <input
                  id="edit-is-active"
                  type="checkbox"
                  checked={editingServer.is_active}
                  onChange={(e) => setEditingServer({ ...editingServer, is_active: e.target.checked })}
                />
                <label htmlFor="edit-is-active">Servidor ativo</label>
              </div>

              <div className="button-group">
                <button type="button" onClick={cancelEditing} className="btn btn-secondary">
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={() => testConnection({
                    host: editingServer.host,
                    db_user: editingServer.db_user,
                    db_password: editingServer.db_password
                  })}
                  disabled={testingConnection || !editingServer.host || !editingServer.db_user}
                  className="btn btn-info"
                >
                  {testingConnection ? 'Testando...' : 'Testar Conexão DB'}
                </button>
                <button type="submit" disabled={loading} className="btn btn-primary">
                  {loading ? 'Salvando...' : 'Salvar Alterações'}
                </button>
              </div>

              {testResult && (
                <div className={`test-result-message ${testResult.success ? 'success' : 'error'}`}>
                  {testResult.message}
                </div>
              )}
            </div>
          </form>
        </div>
      ) : (
        /* Formulário de Novo Servidor - só é exibido quando não está editando */
        <div className="new-server-section">
          <h2>Novo Servidor</h2>
          <form onSubmit={handleAddServer} className="form-card">
            <div className="form-grid">
              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="new-name" className="form-label">
                    Nome do Servidor: <span className="required-star">*</span>
                  </label>
                  <input
                    id="new-name"
                    type="text"
                    placeholder="Nome descritivo do servidor"
                    value={newServer.name}
                    onChange={(e) => setNewServer({ ...newServer, name: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>

                <div className="form-col-50">
                  <label htmlFor="new-host" className="form-label">
                    Host: <span className="required-star">*</span>
                  </label>
                  <input
                    id="new-host"
                    type="text"
                    placeholder="IP ou domínio do servidor"
                    value={newServer.host}
                    onChange={(e) => setNewServer({ ...newServer, host: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>
              </div>

              {/* Seção de credenciais SSH */}
              <div className="form-row">
                <div className="section-header">Credenciais de Acesso SSH</div>
              </div>

              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="new-ssh-username" className="form-label">
                    Usuário SSH:
                  </label>
                  <input
                    id="new-ssh-username"
                    type="text"
                    placeholder="root"
                    value={newServer.username}
                    onChange={(e) => setNewServer({ ...newServer, username: e.target.value })}
                    className="input-field"
                  />
                  <small className="form-help-text">
                    Padrão: root
                  </small>
                </div>

                <div className="form-col-50">
                  <label htmlFor="new-ssh-password" className="form-label">
                    Senha SSH:
                  </label>
                  <input
                    id="new-ssh-password"
                    type="password"
                    placeholder="Senha SSH do servidor"
                    value={newServer.password}
                    onChange={(e) => setNewServer({ ...newServer, password: e.target.value })}
                    className="input-field"
                    required
                  />
                  <small className="form-help-text">
                    Obrigatório — sem valor padrão
                  </small>
                </div>
              </div>

              {/* Seção de credenciais de banco de dados */}
              <div className="form-row">
                <div className="section-header">Credenciais do Banco de Dados</div>
              </div>

              <div className="form-row">
                <div className="form-col-50">
                  <label htmlFor="new-db-user" className="form-label">
                    Usuário DB: <span className="required-star">*</span>
                  </label>
                  <input
                    id="new-db-user"
                    type="text"
                    placeholder="Usuário do banco de dados"
                    value={newServer.db_user}
                    onChange={(e) => setNewServer({ ...newServer, db_user: e.target.value })}
                    className="input-field"
                    required
                  />
                  <small className="form-help-text">
                    Ex: asteriskuser, root
                  </small>
                </div>

                <div className="form-col-50">
                  <label htmlFor="new-db-password" className="form-label">
                    Senha DB: <span className="required-star">*</span>
                  </label>
                  <input
                    id="new-db-password"
                    type="password"
                    placeholder="Senha do banco de dados"
                    value={newServer.db_password}
                    onChange={(e) => setNewServer({ ...newServer, db_password: e.target.value })}
                    className="input-field"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <label htmlFor="new-db-name" className="form-label">
                  Banco de Dados:
                </label>
                <input
                  id="new-db-name"
                  type="text"
                  value="asteriskcdrdb"
                  className="input-field input-disabled"
                  disabled
                />
                <small className="form-help-text">
                  Padrão para Issabel PBX (não pode ser alterado)
                </small>
              </div>

              {/* Configurações adicionais */}
              <div className="form-row">
                <div className="section-header">Configurações Adicionais</div>
              </div>

              <div className="form-row">
                <label htmlFor="new-recordings-path" className="form-label">
                  Caminho das Gravações:
                </label>
                <input
                  id="new-recordings-path"
                  type="text"
                  placeholder="/var/spool/asterisk/monitor"
                  value={newServer.recordings_path}
                  onChange={(e) => setNewServer({ ...newServer, recordings_path: e.target.value })}
                  className="input-field"
                />
                <small className="form-help-text">
                  Caminho padrão para gravações no Issabel
                </small>
              </div>

              <div className="form-row">
                <label htmlFor="new-description" className="form-label">
                  Descrição:
                </label>
                <textarea
                  id="new-description"
                  placeholder="Descrição ou observações sobre este servidor"
                  value={newServer.description}
                  onChange={(e) => setNewServer({ ...newServer, description: e.target.value })}
                  className="input-field textarea-field"
                />
              </div>

              <div className="checkbox-group">
                <input
                  id="new-is-active"
                  type="checkbox"
                  checked={newServer.is_active}
                  onChange={(e) => setNewServer({ ...newServer, is_active: e.target.checked })}
                />
                <label htmlFor="new-is-active">Servidor ativo</label>
              </div>

              <div className="button-group">
                <button
                  type="button"
                  onClick={() => testConnection(newServer)}
                  disabled={testingConnection || !newServer.host || !newServer.db_user || !newServer.db_password}
                  className="btn btn-info"
                >
                  {testingConnection ? 'Testando...' : 'Testar Conexão DB'}
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                >
                  {loading ? 'Salvando...' : 'Adicionar Servidor'}
                </button>
              </div>

              {testResult && (
                <div className={`test-result-message ${testResult.success ? 'success' : 'error'}`}>
                  {testResult.message}
                </div>
              )}
            </div>
          </form>
        </div>
      )}

      {/* Lista de Servidores */}
      <div>
        <h2>Lista de Servidores</h2>
        <div className="server-list-container">
          {servers.length === 0 ? (
            <p className="server-list-empty">Nenhum servidor cadastrado.</p>
          ) : (
            servers.map(server => (
              <div
                key={server.id}
                className={`server-list-item ${server.id === (editingServer?.id) ? 'server-list-item--editing' : ''}`}
              >
                <div className="server-info">
                  <div className="server-header">
                    <strong className="server-name">{server.name}</strong>
                    <span className={`status-indicator ${server.is_active ? 'status-active' : 'status-inactive'}`}></span>
                    <span className={`status-text ${server.is_active ? 'active' : 'inactive'}`}>
                      {server.is_active ? 'Ativo' : 'Inativo'}
                    </span>
                  </div>

                  <div className="server-details">
                    <span className="server-detail-item">
                      <strong>Host:</strong> {server.host}
                    </span>
                    <span className="server-detail-item">
                      <strong>SSH:</strong> {server.username || 'root'}
                    </span>
                    <span className="server-detail-item">
                      <strong>Database:</strong> asteriskcdrdb ({server.db_user})
                    </span>
                    <span className="server-detail-item">
                      <strong>Gravações:</strong> {server.recordings_path}
                    </span>
                    {server.description && (
                      <span className="server-description">
                        {server.description}
                      </span>
                    )}
                  </div>
                </div>

                <div className="server-actions">
                  <button
                    onClick={() => startEditing(server)}
                    className="btn btn-info"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => handleDeleteServer(server.id)}
                    className="btn btn-danger"
                  >
                    Excluir
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ServerManagement;
